<template>
  <!--:class="[
    (gameType==='puzzle' ? 'puzzleClass' : null),
  ]"-->
  <v-flex layout row align-center>
    <v-flex layout column align-center>
      <v-flex layout row align-center>
        <v-chip
          color="primary"
          class="white--text font-weight-bold betaChip"
          small
          >BETA</v-chip
        >
        <v-switch
          v-model="result.isAnalysing"
          inset
          :label="$t('gameTakePicture.isAnalysing')"
        ></v-switch>
      </v-flex>
      <v-flex v-if="result.isAnalysing" layout row align-center>
        <v-switch
          v-model="result.isAnalysingPlants"
          inset
          :label="$t('gameTakePicture.isAnalysingPlant')"
        >
        </v-switch>
      </v-flex>
      <v-flex v-if="result.isAnalysing" class="grey--text">{{
        $t('gameFormCard.explanationTakePictureInputPicture')
      }}</v-flex>
      <v-flex
        v-if="result.isAnalysing"
        style="margin-bottom: 30px"
        layout
        row
        align-center
      >
        <image-input
          v-for="(img, index) in nbPictures"
          style="margin-right: 25px"
          :key="index"
          :imgKey="index"
          :parent="'gameTakePicture'"
          :showImageInfos="false"
          :default="result.pictures[index] || null"
          :langEdition="langEdition"
          :isBorderThick="true"
          @change-image-input="updateImage"
          @error="onImageError"
        />
      </v-flex>
      <v-flex v-if="result.isAnalysing" class="p-2"
        ><v-btn color="primary" @click="launchAnalysis">{{
          $t('gameFormCard.startAnalysis')
        }}</v-btn></v-flex
      >
      <span
        v-if="
          result.isAnalysing &&
          result.expectedResults &&
          result.expectedResults.length
        "
        class="grey--text"
        >{{ $t('gameFormCard.explanationTakePictureTags') }}</span
      >
      <v-flex
        v-if="
          result.isAnalysing &&
          result.expectedResults &&
          result.expectedResults.length
        "
        layout
        row
        align-center
      >
        <div>
          <v-chip
            v-for="word in result.expectedResults"
            :key="word"
            close
            color="red"
            class="ma-2"
            @input="removeKeyWord(word)"
          >
            {{ word }}
          </v-chip>
        </div>
      </v-flex>
    </v-flex>
  </v-flex>
</template>

<script>
import ImageInput from './ImageInput';
// import LanguageTranslator from './LanguageTranslator.vue';
// import ColorPicker from './ColorPicker.vue'

export default {
  name: 'GameTakePicture',
  components: {
    ImageInput,
    // LanguageTranslator,
    // ColorPicker,
  },
  props: {
    gameId: {
      type: String,
      default: null,
    },
    gameType: {
      type: String,
      default: null,
    },
    parameters: {
      type: Object,
      default: null,
    },
    langEdition: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      imageWidth: 200,
      imageHeight: 200,
      nbPictures: 3,
      pictures: [],
      result: {
        expectedResults: [],
        isAnalysing: false,
        isAnalysingPlants: false,
        pictures: [],
      },
      //picturesBase64:[]
    };
  },
  watch: {
    gameType(newValue) {
      return newValue;
    },
    'result.isAnalysing'(val) {
      if (val === false) {
        this.result.isAnalysingPlants = false
      }
      this.$emit('update-take-picture-answer', this.result);
    },
    'result.isAnalysingPlants'(val) {
      this.$emit('update-take-picture-answer', this.result);
    },
  },
  created() {
    if (this.gameType === 'takePicture') {
      this.result.expectedResults = this.parameters.expectedResults;
      this.result.isAnalysing = this.parameters.isAnalysing || false;
      this.result.isAnalysingPlants =
        this.parameters.isAnalysingPlants || false;
      this.result.pictures = this.parameters.pictures || [];
    }
  },
  methods: {
    async updateImage(file, key) {
      if (key !== undefined && file.url.length === 0) {
        // delete image
        this.result.pictures.splice(key, 1);
        //this.picturesBases64.splice(key, 1);
        this.$emit('update-take-picture-answer', this.result);
      } else if (key !== undefined && file.url.length > 0) {
        // change image
        this.result.pictures[key].url = file.url;
        //this.picturesBase64[key].fileBase64=file.dataUrl;
        //this.picturesBase64[key].fileUrl=file.url;
        this.$emit('update-take-picture-answer', this.result);
      } else {
        const picturesUrl = this.addElementToArray(
          this.result.pictures.map((p) => p.url),
          file.url
        );
        this.result.pictures = picturesUrl.map((p) => {
          return { url: p };
        });
        //this.picturesBase64.push({fileBase64:file.dataUrl,fileUrl:file.url});
      }
    },
    async launchAnalysis() {
      await this.$store.commit('app/SET_LOADING');
      for (const picture of this.result.pictures) {
        try {
          console.log('launching analyse', this.result.isAnalysingPlants);
          const { result } = await this.$kuzzle.query({
            controller: 'picture',
            action: 'analyze',
            //fileBase64: picture.fileBase64,
            fileUrl: picture.url,
            isAnalysingPlants: this.result.isAnalysingPlants,
          });
          console.log('analyse results', result);
          // JCS: TODO if isSafe == false

          // const picturesUrl=this.addElementToArray(this.result.pictures.map(p=>p.url), file.url);
          // this.result.pictures = picturesUrl.map(p => {return {url:p};});
          if (result && result.isSafe && result.labels) {
            if (this.result.expectedResults.length === 0) {
              this.$set(this.result, 'expectedResults', result.labels);
            } else {
              this.result.expectedResults = this.addMElementToArray(
                this.result.expectedResults,
                result.labels
              );
            }
            this.$emit('update-take-picture-answer', this.result);
          }
        } catch (error) {
          console.log(error);
        }
      }
      await this.$store.commit('app/UNSET_LOADING');
    },
    addElementToArray(array, elem) {
      var set = new Set(array);
      set.add(elem);
      return Array.from(set);
    },
    addMElementToArray(array, elems) {
      var set = new Set(array);

      elems.forEach((e) => {
        set.add(e);
      });

      return Array.from(set);
    },
    removeKeyWord(word) {
      this.result.expectedResults = this.result.expectedResults.filter(
        (w) => w !== word
      );
      this.$emit('update-take-picture-answer', this.result);
    },
    onImageError(error) {
      console.log('imageError', error.message);
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
};
</script>
<style lang="sass" scoped>
.betaChip
    margin-right: 15px
    border-radius: 5px
div.v-input
 width: 300px
</style>
